import _typeof from "@babel/runtime/helpers/esm/typeof";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.function.name.js";
// Google Tag Manager Class to be injected
var GTM = /*#__PURE__*/function () {
  function GTM(ctx, options) {
    _classCallCheck(this, GTM);
    this.ctx = ctx;
    this.options = options;
  }
  _createClass(GTM, [{
    key: "init",
    value: function init() {
      window[this.options.layer] = window[this.options.layer] || [];
      this.pushEvent({
        event: 'gtm.js',
        'gtm.start': new Date().getTime()
      });
      if (this.options.pageTracking && (!this.options.respectDoNotTrack || !this.hasDNT())) {
        this.initPageTracking();
      }
    }
  }, {
    key: "initPageTracking",
    value: function initPageTracking() {
      var _this = this;
      this.ctx.app.router.afterEach(function (to, from) {
        setTimeout(function () {
          window[_this.options.layer].push(to.gtm || {
            event: _this.options.pageViewEventName,
            pageType: 'PageView',
            pageUrl: to.fullPath,
            routeName: to.name
          });
        }, 0);
      });
    }
  }, {
    key: "pushEvent",
    value: function pushEvent(obj) {
      try {
        if (!window || !window[this.options.layer]) {
          throw new Error('missing GTM dataLayer');
        }
        if (_typeof(obj) !== 'object') {
          throw new Error('event should be an object');
        }
        if (!obj.hasOwnProperty('event')) {
          throw new Error('missing event property');
        }
        window[this.options.layer].push(obj);
      } catch (err) {
        console.error('[ERROR] [GTM]', err);
      }
    }
  }, {
    key: "hasDNT",
    value: function hasDNT() {
      return window.doNotTrack === '1' || navigator.doNotTrack === 'yes' || navigator.doNotTrack === '1' || navigator.msDoNotTrack === '1' || window.external && window.external.msTrackingProtectionEnabled && window.external.msTrackingProtectionEnabled();
    }
  }]);
  return GTM;
}();
export default function (ctx, inject) {
  var options = {
    "id": "GTM-N82M345",
    "pageTracking": true,
    "layer": "dataLayer",
    "pageViewEventName": "nuxtRoute",
    "respectDoNotTrack": false,
    "dev": true,
    "query": {},
    "scriptURL": "//www.googletagmanager.com/gtm.js",
    "noscriptURL": "//www.googletagmanager.com/ns.html",
    "env": {}
  };

  // Create a new Auth instance
  var $gtm = new GTM(ctx, options);
  inject('gtm', $gtm);
  $gtm.init();
}